import api from "../utils/api";

// 🔹 Verify MFA Code & Complete Login
export const verifyMFA = async (mfaCode) => {
    const token = localStorage.getItem("token");

    try {
        const response = await api.post(
            "/mfa/verify",
            { mfaCode },
            {
                headers: { Authorization: `Bearer ${token}` }, // Send token
            }
        );

        if (response.status === 200) {
            localStorage.setItem("token", response.data.token);
            localStorage.setItem("userType", "user");
            // Store final token
            //localStorage.removeItem("tempToken"); // Cleanup temp token
            return response.data;
        }
    } catch (error) {
        return { error: error.response?.data?.message || "Invalid MFA code. Try again." };
    }
};

// 🔹 Enable MFA & Get QR Code
export const enableMFA = async () => {
    try {
        const response = await api.post("/mfa/enable", {}, {
            headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        });

        return response.data; // Contains { qrCode, secret }
    } catch (error) {
        return { error: "Failed to initiate MFA setup." };
    }
};

// 🔹 Confirm MFA Activation
export const confirmMFA = async (mfaCode) => {
    try {
        const response = await api.post("/mfa/confirm", { mfaCode }, {
            headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        });

        return response.data;
    } catch (error) {
        return { error: "Failed to enable MFA. Invalid code?" };
    }
};

// 🔹 Disable MFA
export const disableMFA = async () => {
    try {
        const response = await api.post("/mfa/disable", {}, {
            headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        });

        return response.data;
    } catch (error) {
        return { error: "Failed to disable MFA." };
    }
};
